import { useData } from '../../graphQl'
import * as queries from './appConfig.queries'
import { type AppConfig } from './appConfig.model'

/**
 * returns app config
 */
export const useAppConfig = () => {
  return useData<AppConfig>(queries.getAppConfig)
}
